import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExpirationAlerts = ({ credentials, onRenew, onDismiss }) => {
  const getExpiringCredentials = () => {
    return credentials?.filter(credential => {
      if (!credential?.expirationDate || credential?.status === 'expired') return false;
      const expirationDate = new Date(credential.expirationDate);
      const thirtyDaysFromNow = new Date();
      thirtyDaysFromNow?.setDate(thirtyDaysFromNow?.getDate() + 30);
      return expirationDate <= thirtyDaysFromNow;
    });
  };

  const getExpiredCredentials = () => {
    return credentials?.filter(credential => credential?.status === 'expired');
  };

  const expiringCredentials = getExpiringCredentials();
  const expiredCredentials = getExpiredCredentials();

  if (expiringCredentials?.length === 0 && expiredCredentials?.length === 0) {
    return null;
  }

  const getDaysUntilExpiration = (expirationDate) => {
    const today = new Date();
    const expDate = new Date(expirationDate);
    const diffTime = expDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  return (
    <div className="space-y-4 mb-6">
      {/* Expired Credentials Alert */}
      {expiredCredentials?.length > 0 && (
        <div className="bg-error/10 border border-error/20 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <Icon name="AlertTriangle" size={20} className="text-error mt-0.5" />
            <div className="flex-1">
              <h3 className="font-medium text-error mb-2">
                {expiredCredentials?.length} Credential{expiredCredentials?.length > 1 ? 's' : ''} Expired
              </h3>
              <div className="space-y-2">
                {expiredCredentials?.slice(0, 3)?.map((credential) => (
                  <div key={credential?.id} className="flex items-center justify-between bg-card rounded-lg p-3">
                    <div>
                      <p className="font-medium text-foreground">{credential?.title}</p>
                      <p className="text-sm text-muted-foreground">
                        Expired on {new Date(credential.expirationDate)?.toLocaleDateString()}
                      </p>
                    </div>
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="RefreshCw"
                      iconPosition="left"
                      onClick={() => onRenew(credential)}
                    >
                      Renew
                    </Button>
                  </div>
                ))}
                {expiredCredentials?.length > 3 && (
                  <p className="text-sm text-muted-foreground">
                    And {expiredCredentials?.length - 3} more expired credentials...
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Expiring Soon Alert */}
      {expiringCredentials?.length > 0 && (
        <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <Icon name="Clock" size={20} className="text-warning mt-0.5" />
            <div className="flex-1">
              <h3 className="font-medium text-warning mb-2">
                {expiringCredentials?.length} Credential{expiringCredentials?.length > 1 ? 's' : ''} Expiring Soon
              </h3>
              <div className="space-y-2">
                {expiringCredentials?.slice(0, 3)?.map((credential) => {
                  const daysLeft = getDaysUntilExpiration(credential?.expirationDate);
                  return (
                    <div key={credential?.id} className="flex items-center justify-between bg-card rounded-lg p-3">
                      <div>
                        <p className="font-medium text-foreground">{credential?.title}</p>
                        <p className="text-sm text-muted-foreground">
                          {daysLeft > 0 ? `Expires in ${daysLeft} day${daysLeft > 1 ? 's' : ''}` : 'Expires today'}
                        </p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Button
                          variant="ghost"
                          size="sm"
                          iconName="X"
                          onClick={() => onDismiss(credential?.id)}
                        />
                        <Button
                          variant="outline"
                          size="sm"
                          iconName="RefreshCw"
                          iconPosition="left"
                          onClick={() => onRenew(credential)}
                        >
                          Renew
                        </Button>
                      </div>
                    </div>
                  );
                })}
                {expiringCredentials?.length > 3 && (
                  <p className="text-sm text-muted-foreground">
                    And {expiringCredentials?.length - 3} more expiring credentials...
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpirationAlerts;